import { Heart, Users, Award, Sparkles } from 'lucide-react';

const ITEMS = [
  {
    id: 'individual-attention',
    icon: <Users className="w-10 h-10 text-[#43b6b8]" />,
    title: 'Atención Individualizada',
    description: 'Cada estudiante recibe apoyo personalizado según sus necesidades y estilo de aprendizaje único.'
  },
  {
    id: 'safe-environment',
    icon: <Heart className="w-10 h-10 text-[#43b6b8]" />,
    title: 'Ambiente Seguro y Familiar',
    description: 'Un espacio cálido donde los niños se sienten seguros, valorados y motivados a aprender.'
  },
  {
    id: 'inclusive-environment',
    icon: <Sparkles className="w-10 h-10 text-[#43b6b8]" />,
    title: 'Ambiente Inclusivo que Inspira Aprendizaje',
    description: 'En Rise & Shine Learning Zone fomentamos un ambiente inclusivo donde cada estudiante es valorado, respetado y acompañado según sus necesidades individuales. Creemos en la diversidad como una fortaleza, promoviendo experiencias educativas personalizadas que atienden distintos estilos de aprendizaje, ritmos de desarrollo y características únicas. Nuestro enfoque integra apoyo académico, desarrollo socioemocional y estrategias basadas en evidencia, creando un espacio seguro, empático y estimulante donde todos los estudiantes pueden aprender, crecer y alcanzar su máximo potencial.'
  },
  {
    id: 'integral-development',
    icon: <Award className="w-10 h-10 text-[#43b6b8]" />,
    title: 'Enfoque en Desarrollo Integral',
    description: 'Más allá de lo académico, fomentamos el crecimiento emocional y social de cada estudiante.'
  }
];

export const HomeWhyChooseUs = () => (
  <section className="py-20 md:py-28 bg-[#F3F0EA]" data-testid="why-choose-us-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
      <div className="text-center mb-16">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#d3b163] mb-4 block">¿Por Qué Elegirnos?</span>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900 mb-4">
          Lo que hace especial a Rise & Shine
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {ITEMS.map((item) => (
          <div
            key={item.id}
            className="bg-white p-8 rounded-2xl card-hover shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
            data-testid={`why-choose-card-${item.id}`}
          >
            <div className="mb-4">{item.icon}</div>
            <h3 className="text-lg sm:text-xl font-medium text-stone-800 mb-3">{item.title}</h3>
            <p className="text-base text-stone-700 leading-relaxed">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
